import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import useMedia from 'use-media';
import common from "../../resources/js/common/common"


import { Button } from "../atoms/button";
import { Label } from '../atoms/label';
import { Link } from '../atoms/link';
import { Line } from '../atoms/line';
import { CheckboxSeachSetForm } from "../molecules/checkboxSeachSetForm";
import { ModalOptionForm } from '../molecules/modalOptionForm';
import { PullDownOptionForm } from '../molecules/pullDownOptionForm';
import { searchResultApi, golfFacility } from "../../const";
import { Image } from '../atoms/image';
import img_save from '../../resources/icons/ico_save.svg';
import img_memo from '../../resources/icons/ico_memo.svg';

export const GolfSearchConditionsContainer = (props) => {
    const { playDate1,
        group,
        course,
        detailCondition,
        setDetailCondition,
        startTime,
        setGroup,
        setKaiinken,
        kaiinken,
        addTeeTimeList,
        setSearchResult,
        onClickOpenSavedSearchCriteriaWindow,
        onClickOpenSelectDateWindow,
        onClickOpenStartTimeWindow,
        onClickOpenSelectAreaWindow,
        setCourse,
        setReserveCheckInfo,
        onClickOpenConfirm,
        setChangeReserveNo,
        changeReserveNo
    } = props;

    const [groupNumber, setGroupNumber] = useState("1");
    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");

    // プレー日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(playDate1);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();

        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    // スタート時刻表示処理
    const getStartTimeToString = () => {
        let textValue = "";
        let onCheckFlg = false;
        for (var i in startTime) {
            if (startTime[i].checked === true) {
                textValue = textValue + (textValue == "" ? "" : ", ");
                textValue = textValue + startTime[i].value;
                onCheckFlg = true;
            }
        }
        return (onCheckFlg ? textValue : "選択なし");
    }

    // 施設表示処理
    const getCourseName = () => {
        const array = course.filter((data) => {
            return data.checked === true;
        });

        if (array.length === 0) {
            return "選択なし";
        }

        if (array.length === course.length) {
            return "すべて"
        } else {
            const text = array.map((data) => {
                return data.value;
            });
            return text.join(", ");
        }
    }

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        group.forEach((data) => {
            if (data.selected === true) setGroupNumber(data.id);
        });
        kaiinken.forEach((data) => {
            if (data.selected === true) setKaiinkenNumber(data.id);
        });
    }, []);

    // 選択した組数をstoreに保存
    const onChangeGroup = (e) => {
        setGroupNumber(e.target.value);

        group.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setGroup(group);
    };

    const onChangeKaiinkenName = (e) => {
        setKaiinkenNumber(e.target.value);
        kaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
                common.doPost(golfFacility, {kaiinKind:data.kaiinkenSyubetCd,sisetuCd:data.sisetuCd}, afterGetFacility);
            } else {
                data.selected = false;
            }
        })
        setKaiinken(kaiinken);
    }

    // 施設取得後処理
    const afterGetFacility = (res) => {
        const data = res.data.map((item) => {
            return {
                id: item.courseid,
                facilityCd: item.facility_cd,
                value: item.facility_name,
                category: item.hotel_category_name,
                class: "area_course",
                checked: true,
                zip: item.zip,
                address: item.address,
                access_car: item.access_car,
                facility_overview_title: item.facility_overview_title,
                facility_overview_detail: item.facility_overview_detail,
                url: item.url,
                image_path: item.image_path,
                memberShipAuth: item.memberShipAuth,
                sortNum:parseInt(item.inside_category_sort),
            };
        });
        //表示施設のソート処理
        data.sort(function(first,second){
            if (first.sortNum > second.sortNum){
                return 1;
            }else if (first.sortNum < second.sortNum){
                return -1;
            }else{
                return 0;
            }
        })

        setCourse(data);
    }

    // 選択したプレースタイルをstoreに保存
    const onChangePlay = (e) => {
        detailCondition.forEach((data) => {
            if (e.target.checked && data.id === e.target.value) {
                data.checked = true;
            } 
            if(!e.target.checked && data.id === e.target.value){
                data.checked = false;
            }
        })
        setDetailCondition(detailCondition);
    };

    // 検索ボタン押下時
    const onClickSearch = () => {
        addTeeTimeList([]);
        setReserveCheckInfo([]);
        setChangeReserveNo("");
        // 選択した詳細条件をstoreに保存
        const arry = [];
        const elements = document.getElementsByClassName("play_style");
        for (let i in elements) {
            if (elements[i].checked == true) {
                arry.push(elements[i].value);
            }
        }

        for (let i in detailCondition) {
            let index = arry.indexOf(detailCondition[i].id);
            if (index >= 0) {
                detailCondition[i].checked = true;
            } else {
                detailCondition[i].checked = false;
            }
        }

        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id);
        });

        const courseArray = [];
        course.forEach((data) => {
            if (data.checked === true) courseArray.push(data.id);
        });

        //選択された会員権から施設コードを詰め込む
        // const courseArrayKaiinken = [];
        // kaiinken.forEach((data) => {
        //     if (data.selected === true) courseArrayKaiinken.push(data.facilityCd);
        // });

        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        const detailArray = [];
        detailCondition.forEach((data) => {
            if (data.checked === true) detailArray.push(data.id);
        });

        const startTimeArray = [];
        let startTimeFlg = false;
        startTime.forEach((data) => {
            if (data.checked === true) startTimeFlg = true;
            if (data.checked === true) startTimeArray.push(data.id);
        });
        // スタート時間が1件もチェックが入っていない場合、全件チェック
        if (startTimeFlg === false) {
            startTime.forEach((data) => {
                startTimeArray.push(data.id);
            });
        }

        const playDate = new Date(playDate1);
        let y = playDate.getFullYear();
        let m = playDate.getMonth() + 1;
        let d = playDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // リクエスト情報設定
        const req = {
            playDate: `${y}-${m}-${d}`,
            partyCount: groupNumber,
            courseId: courseArray,
            playStyle: detailArray,
            teeTime: startTimeArray,
            days:'1',
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
        };

        console.log(req);
        common.doPost(searchResultApi, req, afterSearchResult);
    }

    let resDataList = [];
    //検索API通信後の処理
    const afterSearchResult = (res) => {
        //検索API戻り値を一時的に保持
        resDataList = res;
        // common.doPost(golfFacility, {}, afterGolfFacility);
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                common.doPost(golfFacility, {kaiinKind:data.kaiinkenSyubetCd,sisetuCd:data.sisetuCd}, afterGolfFacility);
            }
        })
    }
    
    //施設取得API通信後の処理
    const afterGolfFacility = (facilityData) => {
        //検索APIの戻り値を格納
        const res = resDataList;
        if(res.data.golfCourses){
            const result = facilityData.data.map((item) => {

                for (let i = 0; i < res.data.golfCourses.length; i++) {
                    if (res.data.golfCourses[i].name === item.facility_name) {
                        const resData = res.data.golfCourses[i];
                        const fac = {
                            courseid: item.courseid,
                            zip: item.zip,
                            address: item.address,
                            access_car: item.access_car,
                            facility_overview_title: item.facility_overview_title,
                            facility_overview_detail: item.facility_overview_detail,
                            url: item.url,
                            image_path:item.image_path,
                        }
                        Object.assign(resData, fac);
                        return resData;
                    }
                }
                return null;
            });

            const re = result.filter(item => item != null);

            console.log("data");
            console.log(res.data);
            const resultData = {
                sort: "人気順",
                golfCourses: re
            }

            //表示施設のソート処理
            resultData.golfCourses.sort(function(first,second){
                if (first.facilitySort > second.facilitySort){
                    return 1;
                }else if (first.facilitySort < second.facilitySort){
                    return -1;
                }else{
                    return 0;
                }
            })

            console.log(resultData);
            setSearchResult(resultData);
        }else{
            setSearchResult([]);
        }
        // 画面遷移
        history.push("/reserve/golf/searchResult");
    }

    return (
        <div style={Phone ? styles.topSp : styles.top}>
            {Phone ?
                // レスポンシブ対応 
                <div></div>
                :
                <div style={styles.div}>
                    <ModalOptionForm
                        divClass={"wrapSide"}
                        title={"プレー日"}
                        onClick={onClickOpenSelectDateWindow}
                        text={getDateToString()} />
                    <ModalOptionForm
                        divClass={"wrapSide"}
                        title={"スタート時間"}
                        onClick={onClickOpenStartTimeWindow}
                        text={getStartTimeToString()} />
                    {/* 後でコメントアウト外す */}
                    <ModalOptionForm
                        divStyle={styles.wrap}
                        labelStyle={styles.label} title={"ゴルフ場"}
                        style={styles.modalOptionStyle}
                        onClick={onClickOpenSelectAreaWindow}
                        text={getCourseName()} />
                    <PullDownOptionForm
                        divClass={"wrapSide"}
                        title={"組数"}
                        selectClass={"pullDownOptionStyle"}
                        data={group}
                        state={groupNumber}
                        onChange={onChangeGroup} />
                    <PullDownOptionForm
                        divClass={"wrapSide"}
                        title={"会員権選択"}
                        selectClass={"pullDownOptionStyle"}
                        data={kaiinken}
                        state={kaiinkenNumber}
                        onChange={onChangeKaiinkenName} />
                    <Label label="詳細条件" style={styles.title} />
                    <Line style={styles.lineStyle} />
                    <CheckboxSeachSetForm
                        title="プレイスタイル"
                        checkData={detailCondition} 
                        onChange={onChangePlay}/>
                    <Line style={styles.lineStyle} />
                    <Button buttonText="検 索" className="searchBtn" onClick={onClickSearch} />
                    <div style={styles.save}>
                        <Image image={img_save} style={styles.imageSave} />
                        <Link linkTitle={"この検索条件を保存"}
                            style={styles.saveConditions}
                            onClick={onClickOpenConfirm} />
                    </div>
                    <div style={styles.save}>
                        <Image image={img_memo} style={styles.imageSave} />
                        <Link linkTitle={"保存した検索条件"}
                            style={styles.saveConditions}
                            onClick={onClickOpenSavedSearchCriteriaWindow} />
                    </div>
                </div>
            }
        </div>
    )
}

const styles = {
    top: {
        display: "inline-block",
        textAlign: "center",
        verticalAlign: "top",
        marginTop: "70px",
        width: "16%",
    },
    topSp: {
        display: "inline-block",
        verticalAlign: "top",
    },
    div: {
        backgroundColor: "white",
        //float: "left",
        //width: "15%",
        width: "calc(100% - 30px)",
        padding: "30px 15px",
        textAlign: "left",
    },
    title: {
        color: "#808080",
        fontSize: "small",
        fontWeight: "bold",
    },
    lineStyle: {
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
    },
    checkAreaStyle: {
        color: "#696969",
        width: "100%",
        borderBottom: "solid 1px #696969",
        marginTop: "15px",
        marginBottom: "15px",
        cursor: "pointer",
    },
    save: {
        borderBottom: "1px solid",
        marginBottom: "30px",
        fontSize: "small",
        width: "fit-content",
        display: "flex",
    },
    imageSave: {
        position: "absolute",
        display: "block",
    },
    saveConditions: {
        marginLeft: "25px",
        cursor: "pointer",
        display: "block",
    },
}

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        group: state.group,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        kaiinken:state.kaiinken,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        },
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
        setChangeReserveNo: (item) => {
            dispatch({ type: "CHANGE_RESERVE_NO", payload: { changeReserveNo: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfSearchConditionsContainer);